import script from "./form-subject-field.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-subject-field.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__